// Typed accessor for the interview content defined in
// src/content/interview-content.json — the single source of truth that
// scripts/generate-tts.mjs also reads to produce the qNN.mp3 prompts the
// subject hears. It lives under src/ (not scripts/) so the app can import it
// in-root: a cross-root src/ -> scripts/ JSON import fails the tsc typecheck.
// Importing it here rather than inlining keeps the question text the subject is
// recorded answering in lockstep with that audio.

import content from "@/content/interview-content.json";

export interface InterviewQuestion {
  id: string;
  text: string;
}

export const INTERVIEW_QUESTIONS: readonly InterviewQuestion[] =
  (content as { questions: InterviewQuestion[] }).questions;

export interface ConsentStatement {
  id: string;
  text: string;
}

// End-of-interview consent statements (build-order step 9). v1 text is
// placeholder/seed only — lawyer review is deferred to v2 per
// docs/workstream-k-spec.md. Sourced from the content JSON for now; once the
// step-10 backend lands, the same shape is fetched from the
// interview_consent_statements table with no consumer change.
export const FINAL_CONSENT_STATEMENTS: readonly ConsentStatement[] =
  (content as { final_consent_statements: ConsentStatement[] }).final_consent_statements;
